
export type TAnimationState = 'in' | 'out';

export type TSlideOutType = 'left' | 'top';

export enum  EAxis {
  left = 'X',
  top = 'Y'
}
